import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/backbutton.css';

const BackButton = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  };

  return (
    <button onClick={goBack} className='back-button'>
      Explore <span className="short-label">E</span>
    </button>

  );
};

export default BackButton;
